import { InjectionToken } from '@angular/core';
import { Capacitor } from '@capacitor/core/types/global';

export const CAPACITOR_TOKEN = new InjectionToken<typeof Capacitor>('CAPACITOR_TOKEN');
